export default "__VITE_ASSET__CZTL0$_i__"